import { Reveal, Eyebrow } from "./Reveal";

export const Introduction = () => (
  <section data-testid="introduction-section" className="relative py-28 lg:py-44">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>The Firm</Eyebrow>
            <h2 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#1F1E1B] leading-[1.08]">
              A private perspective on <span className="italic">institutional capital.</span>
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:pt-16">
          <Reveal delay={0.1}>
            <p className="text-base sm:text-lg font-light leading-relaxed text-[#1F1E1B]/85">
              We bring together strategic advisory, transaction origination and long-term investment
              relationships.
            </p>
            <p className="mt-6 text-base sm:text-lg font-light leading-relaxed text-[#6E6A61]">
              Our work spans private businesses, real assets, sports and alternative investments, serving
              clients whose objectives extend beyond conventional asset class boundaries.
            </p>
            <p className="mt-6 text-base sm:text-lg font-light leading-relaxed text-[#6E6A61]">
              The firm combines the relationships and personal service of a multi-family office with the
              transaction capabilities of a specialist investment advisory house.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
